<!-- grid -->
<kor-grid columns="2">
  <app-page-card
    *ngFor="let page of pages"
    [routerLink]="['/page/' + page.uid, { version: page.versionUid }]"
    (click)="sharedService.logEvent('gallery_page_clicked')"
    [thumbnail]="page.thumbnail"
  >
    <h3>
      <img height="24" width="24" [src]="page.product?.thumbnail" />{{
        page.product.name
      }}
      · {{ page.name }}
      <kor-icon
        icon="favorite"
        button
        color="rgb(var(--accent-1))"
        (mouseover)="$event.stopPropagation()"
        (click)="
          removePage({ pageUid: page.uid, versionUid: page.versionUid });
          $event.stopPropagation()
        "
      ></kor-icon>
    </h3>
    <hr />
  </app-page-card>
</kor-grid>

<!-- details -->
<div class="details">
  <h3>
    <img height="24" width="24" src="assets/imgs/collections.png" />{{
      collection?.name
    }}
  </h3>
  <hr />
  {{ pages.length }} pages
  <br />
  modified at {{ (collection?.modifiedAt.toDate() | date)?.toLowerCase() }}
  <hr />
  <div>
    <kor-menu-item
      icon="person"
      label="invite member"
      [toggle]="false"
      disabled
    ></kor-menu-item>
    <kor-menu-item
      icon="delete"
      label="delete collection"
      [toggle]="false"
      (click)="deleteCollection()"
    ></kor-menu-item>
  </div>
</div>
